<template>
    <div class="vue-tempalte">
      <br><br>
      <form @submit.prevent="userPasswordLogin">
          <div class="text-center" style="cursor: pointer;">
            <img src="/btn_google_signin_dark_normal_web.png" v-on:click.prevent="userGoogleLogin()">
          </div>
          <br>

          <p class="text-center font-weight-bold">OR</p>

          <div class="card">
            <div class="card-header text-center font-weight-bold">
              SignIn with <br> Registered Email and Password
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Email Address</label>
                    <input type="email" class="form-control form-control-lg" v-model="formUser.email" />
                </div>

                <div class="form-group">
                    <label>Password</label>
                    <input type="password" class="form-control form-control-lg" v-model="formUser.password" />
                </div>

                <div class="form-group text-center">
                  <button type="submit" class="btn btn-dark" v-on:click.prevent="userPasswordLogin()">Submit</button>
                </div>
            </div>
            <div class="card-footer text-center ">
              <router-link to="/auth/forgotPassword">Forgot password ?</router-link>
              <br>
              <router-link to="/auth/signup">User Registration</router-link>
            </div>
          </div>

      </form>

      <div align="center" class="ml-4">
          <label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
          <scale-loader :loading="loading"></scale-loader>
      </div>

  </div>
</template>

<script>
import { firebase } from '@firebase/app'
import 'firebase/auth'
// import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth"

import axios from 'axios'
import ScaleLoader from '@/components/ScaleLoader'

export default {
  data () {
    return {
      formUser: {
        orgId: '',
        email: '',
        password: ''
      },

      loading: false,
      loadingMsg: null
    }
  },

  components: {
    ScaleLoader
  },

  created () {
  },

  methods: {
    userGoogleLogin(){
        var self = this
        //const auth = getAuth()
        var provider = new firebase.auth.GoogleAuthProvider()
        provider.setCustomParameters({
          prompt: 'select_account'
        })

        firebase.auth()
          .signInWithPopup(provider)
          .then((result) => {
              /** @type {firebase.auth.OAuthCredential} */
              var credential = result.credential
              // This gives you a Google Access Token. You can use it to access the Google API.
              var googleToken = credential.idToken

              // The signed-in user info.
              const user = result.user.email
              if (user) {
                  self.getUserPermissions(googleToken, "Google")
              }
              else {
                  self.userLoggedIn = false
                  self.userName = ''
              }

          }).catch((error) => {
            // Handle Errors here.
            const errorMessage = error.message;
            // The email of the user's account used.
            //const email = error.email;
            // The AuthCredential type that was used.
            //const credential = GoogleAuthProvider.credentialFromError(error);
            self.$alert(String(errorMessage))
          });
    },

    userPasswordLogin () {
        var self = this

        if (this.formUser.email.trim() == '' || this.formUser.password.trim() == '') {
          self.$alert('All the values are Required.')
          return
        }

        // SignIn User with Session Persisitence
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
          firebase.auth().signInWithEmailAndPassword(this.formUser.email, this.formUser.password).then(() => {
            var user = firebase.auth().currentUser
            if (user) {
                user.getIdToken().then(token => {
                    self.getUserPermissions(token, "Firebase")
                })
            }
            else {
                self.userLoggedIn = false
                self.userName = ''
            }
          })
          .catch((error) => {
              self.$alert(String(error))
          })
        })
        .catch((error) => {
            self.$alert(String(error))
        })

    },
          
    // Get user permissions using token issued by authentication
    getUserPermissions(token, oAuthProvider){
        var self = this

        self.loading = true
        self.loadingMsg = 'Getting User Permissions...'
        // Check if the user-org combination exists in the backend
        axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_ROOT_API,
          url: '/GetUserOrg/',
          headers: {
            Authorization: 'Bearer ' + token,
            //OrgId: this.formUser.orgId.trim(),
            OauthProvider: oAuthProvider,
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function (response) {
          // Reset loading message
          self.loading = false
          self.loadingMsg = null

          if (response.data.err != '') {
            console.log('Error:' + response.data.err)
            self.$alert(String(response.data.err))
            self.bus.$emit('logOut')
          } else {
              self.saveUserProfile(response.data.org)
              // Trigger events to refresh - App.Vue - Header
              self.bus.$emit('logIn')
              // Send user to Home page
              self.$router.push('/GetCheckin')
          }
        })
        .catch(function (error) {
            // Reset loading message
            self.loading = false
            self.loadingMsg = null
            console.log(error)
            self.$alert(String(error))
            self.saveUserProfile('')
        })
        
    },

  }

}
</script>


